__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-email-messaging/v3_4_15/";